<template>
    <div>
        <canvas ref="canvas"></canvas>
    </div>
</template>

<script>
import { Line } from "vue-chartjs/legacy";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    Filler,
} from "chart.js";

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    Filler,
);

export default {
    name: "AreaChart",
    extends: Line,

    props: {
        labelsData: { type: Array, default: () => [] },
        valuesData: { type: Array, default: () => [] },
        chartData: { type: Object, default: () => ({ datasets: [] }) },
    },

    methods: {
        renderAreaChart() {
            const ctx = this.$refs.canvas.getContext("2d");

            const gradient = ctx.createLinearGradient(0, 0, 0, 300);
            gradient.addColorStop(0, "rgba(243,156,18,0.35)");
            gradient.addColorStop(1, "rgba(243,156,18,0)");

            this.renderChart(
                {
                    labels: this.labelsData,
                    datasets: [
                        {
                            label: "Risk %",
                            data: this.valuesData,
                            backgroundColor: gradient,
                            borderColor: "#f39c12",
                            fill: true,
                            borderWidth: 3,
                            pointRadius: 0,
                            tension: 0.4,
                        },
                    ],
                },
                {
                    responsive: true,
                    maintainAspectRatio: false,

                    interaction: {
                        mode: "index",
                        intersect: false,
                    },

                    plugins: {
                        legend: { display: false },

                        tooltip: {
                            enabled: true,
                            intersect: false,
                            mode: "index",
                            padding: 10,
                            backgroundColor: "rgba(50, 50, 50, 0.85)",
                            titleFont: { size: 13 },
                            bodyFont: { size: 13 },
                            displayColors: false,

                            callbacks: {
                                label(context) {
                                    return `Risk: ${context.parsed.y}%`;
                                },
                            },
                        },
                    },

                    scales: {
                        x: {
                            grid: { display: false },
                        },
                        y: {
                            beginAtZero: true,
                            ticks: { stepSize: 1 },
                        },
                    },
                },
            );
        },
    },

    mounted() {
        this.renderAreaChart();
    },
};
</script>
